
import React from "react";
import AuditLogTable from "@commons/audit-logs/AuditLogTable";

const AuditLogsPage = () => {
  return <AuditLogTable />;
};

export default AuditLogsPage;
